import { render, staticRenderFns } from "./SegmentBox.vue?vue&type=template&id=4bbb8a5c&"
import script from "./SegmentBox.vue?vue&type=script&lang=js&"
export * from "./SegmentBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports